export function normalizarResponse(result) {
    let resultado = new resultadoRequisicao(result);
    return resultado;
}

export function resultadoRequisicao(result) {
    this.sucesso = true;
    this.retorno = null;
    this.erros = [];

    const response = (result.response) ? result.response : null;
    const data = (result.data) ? result.data : null;
    if (response && response.data && response.data.erros) {
        this.sucesso = false;
        this.erros = response.data.erros.map(erro => erro.mensagem);
    } else if (result && result.data) {
        this.retorno = data;
        this.sucesso = true;
    }

}



// WEBPACK FOOTER //
// ./src/services/Api.config.service.js